import api from "@/service";
import { Toast } from "antd-mobile";
import { routerRedux } from "dva/router";
import { compact } from "lodash";

const {
  // 查询管理员虚拟币
  currencyCountOfAdmin,
  // 查询管理员可分配功能组
  adminFindLoginName,

  // 查管理员
  apiEnterpriseAdminGetList,
  // 添加管理员
  apiEnterpriseAddAdmin,
  // 修改管理员
  adminUpdate,
} = api

export default {
  namespace: 'enterprisegroup',
  state: {
    loginMsgUser: {},   // 当前登录的管理员信息

    adminListDatas: [],   // 管理员列表数据
    
    pageNo: 1,
    pageTotalNum: 1,

    selectUserList: [],
    selectUserListUidArr: [],
  },
  subscriptions: {
    setup({dispatch, history}){
      history.listen(localhost => {
        if(/enterpriseGroupList/.test(localhost.pathname)){
          // dispatch({
          //   type: 'getEnterpriseGroupList',
          //   payload: {
          //     pageNo:1,
          //     pageSize: 10
          //   }
          // })
          console.log('企业群组, 查列表?')
        }
        if(/enterpriseGroupAdd/.test(localhost.pathname)){
          
        }
      })
    }
  },
  effects: {
    // 查企业群组
    *getEnterpriseGroupList({payload},{put ,call}){
      let datas = yield call(apiEnterpriseAdminGetList,payload)

      if(datas.data&&datas.status == 200) {
        let adminList = datas.data
        let count = yield call(
          currencyCountOfAdmin,
          adminList.map(item => item.id)
        )
        if(count.status == 200){
          let adminCount = count.data
          adminList = adminList.map(item => {
            return {
              ...item,
              ...adminCount[item.id],
            }

          })
          yield put({
            type: 'updateState',
            payload: {
              adminListDatas: adminList|| [],
              pageNo: datas.pages,
              pageTotalNum: Math.ceil( datas.total/ 10 )
            }
          })
        }
      } else {
        yield put({
          type: 'updateState',
          payload: {
            adminListDatas: [],
            pageNo: 0,
            pageTotalNum: 0,
          }
        })
      }
      return Promise.resolve(true);
    },
    // 查询登录的管理员所分配的功能组
    *getAdminFindLoginName({payload},{put, call}){
      let data = yield call(adminFindLoginName, payload)
      if (data.status == 200 && data.data) {
        yield put({
          type: "updateState",
          payload: {
            loginMsgUser: data.data,
          },
        });
      }
    },
    // 添加管理员
    *subUserAdminAdd({ payload }, { call, put }) {
      let data = yield call(apiEnterpriseAddAdmin, payload)
      if (data.status == 200 || data.status == 392) {
        return data
      } else {
        throw data
      }
    },
    // 修改管理员
    *adminUpdateManager({ payload }, { put, call }) {
      let data = yield call(adminUpdate, payload);
      if (data.status == 200) {
          Toast.success(data.message, 1.5);
          window.history.go(-1);
      }
  },
  },
  reducers: {
    updateState(state, { payload }){
      return {
        ...state,
        ...payload,
      }
    },
    addSelectUserList(state, { data }) {
      console.log(data, state.selectUserList)
      let arr = [...state.selectUserList]
      let uidArr = arr.map(item => item.uid)
      if (!uidArr.includes(data.uid)) {
        arr.push(data)
      }
      return {
        ...state,
        selectUserList: arr,
        selectUserListUidArr: arr.map(item => item.uid)
      }
    },
    removeSelectUserList(state, { data }) {
      let arr = [...state.selectUserList]
      let uidArr = arr.map(item => item.uid)
      if (uidArr.includes(data.uid)) {
        arr.splice(uidArr.indexOf(data.uid), 1)
      }
      return {
        ...state,
        selectUserList: arr,
        selectUserListUidArr: arr.map(item => item.uid)
      }
    },
    deleteSelectUserList(state) {
      return {
        ...state,
        selectUserList: [],
        selectUserListUidArr: []
      }
    },
    setSelectUserList(state, { data }) {
      return {
        ...state,
        selectUserList: data,
        selectUserListUidArr: data.map(item => item.uid)
      }
    },
    setSelectAll(state, { data }) {
      let arr = [...state.selectUserList]
      let uidArr = [...state.selectUserList].map(item => item.uid);
      data.map(item => {
        if (!uidArr.includes(item.uid)) {
          arr.push(item)
        }
      })
      return {
        ...state,
        selectUserList: arr,
        selectUserListUidArr: arr.map(item => item.uid)
      }
    },
    setEmpty(state, { data }) {
      let arr = [...state.selectUserList]
      let uidArr = [...state.selectUserList].map(item => item.uid);
      data.map(item => {
        if (uidArr.includes(item.uid)) {
          arr.splice(arr.map(item => item.uid).indexOf(item.uid), 1)
        }
      })
      return {
        ...state,
        selectUserList: arr,
        selectUserListUidArr: arr.map(item => item.uid)
      }
    }
  }
}